export default function headerBurger() {
  const burger = document.querySelector(".header__burger");
  const header = document.querySelector(".header");

  burger.addEventListener("click", (e) => {
    const isActive = header.classList.toggle("mobile-open");
    burger.classList.toggle("burger-open");
    if(isActive) {
      document.documentElement.style.overflow = 'hidden';

    } else {
      document.documentElement.style.overflow = 'unset';
    }
  })
}

